module.exports = __webpack_public_path__ + "static/img/indesign.6395ef72.png";